// extracted by mini-css-extract-plugin
export default {"group":"conversation-group_group__nRU3-","title":"conversation-group_title__CkBij","subgroup":"conversation-group_subgroup__chq5R"};